import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, message, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { PlusOutlined } from '@ant-design/icons';
import { queryKeys } from '../../../services/react-query/queryKeys';
import DynamicTableAnt from '../../../hooks/DynamicTableAnt';
import Heading from '../../common/Heading/Heading';
import {
  deletePatientInsurance,
  getPatientInsuranceCoverage,
} from '../../../network/PatientCoverage';
import { useNavigate } from 'react-router-dom';
import StatusTag from '../../../hooks/StatusHook';

const PatientCoverage = ({ t }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getPatientInsuranceCoverage],
    queryFn: () => getPatientInsuranceCoverage(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deletePatientInsurance(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message);
          return false;
        }
        client.invalidateQueries({
          queryKey: [queryKeys.getPatientInsuranceCoverage],
        });
        message.success('Deleted successfully');
        // message.success('تم الحذف بنجاح');
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title: t.patientName,
      dataIndex: 'patient_name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return String(record.patient_name)
          .toLowerCase()
          .includes(value.toLowerCase());
      },
    },
    {
      title: t.itemCode,
      dataIndex: 'item_code',
    },
    {
      title: t.insurancePlan,
      dataIndex: 'insurance_plan',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.modeOfApproval,
      dataIndex: 'mode_of_approval',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.InsurancePayor,
      dataIndex: 'insurance_payor',
    },
    {
      title: t.status,
      dataIndex: 'status',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 150,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                navigate(`/patient_coverage/edit/${record.name}`);
              }}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title="Delete the Patient Insurance Coverage?"
              description="Are you sure to delete?"
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  // const dataTable = data?.data?.map(
  //   (item, index) => ({
  //       key: index,
  //       ...item,
  //     })
  // );
  const dataTable = Array.isArray(data?.data)
    ? data?.data?.map((item, index) => ({
        key: index,
        ...item,
      }))
    : [];
  return (
    <div className="eligibility">
      <Heading
        title={t.Insurances}
        subTitle={t.PatientCoverage}
        path="/patient_coverage"
      />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        // titleBtn={t.addEligibilityPlan}
        Placeholder={t.searchPatient}
        // pathBtn="/add-patient"
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              navigate('/patient_coverage/add');
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />
            {t.addPatientInsuranceCoverage}
          </Button>
        }
      />
    </div>
  );
};

export default PatientCoverage;
